// Test IDs for the Landing + Style Guide screens of GymFlow Phase One.
// Naming follows kebab-case `<feature>-<element>`.

export const LANDING = {
    root: 'landing-root',
    enterStyleGuideBtn: 'landing-enter-style-guide-btn',
    secondaryLearnBtn: 'landing-learn-btn',
    heroTitle: 'landing-hero-title',
};

export const HEADER = {
    root: 'app-header',
    logo: 'app-header-logo',
    homeLink: 'app-header-home-link',
    styleGuideLink: 'app-header-style-guide-link',
    themeToggle: 'app-header-theme-toggle',
    mobileMenuToggle: 'app-header-mobile-menu-toggle',
    mobileMenu: 'app-header-mobile-menu',
};

export const STYLE_GUIDE = {
    root: 'style-guide-root',
    colorsSection: 'sg-colors-section',
    typographySection: 'sg-typography-section',
    buttonsSection: 'sg-buttons-section',
    cardsSection: 'sg-cards-section',
    badgesSection: 'sg-badges-section',
    inputsSection: 'sg-inputs-section',
    exerciseMockupSection: 'sg-exercise-mockup-section',
    motionSection: 'sg-motion-section',
    completeSetBtn: 'sg-complete-set-btn',
    btnPrimary: 'sg-btn-primary',
    btnSecondary: 'sg-btn-secondary',
    btnDestructive: 'sg-btn-destructive',
    btnGhost: 'sg-btn-ghost',
    inputWeight: 'sg-input-weight',
    inputReps: 'sg-input-reps',
};
